import React from "react";
import "./style.scss";

const Legend = ({ items }) => {
  // Kiểm tra items có phải array không
  if (!items || !Array.isArray(items)) {
    return (
      <div className="legend">
        <div className="legend-title">THỂ THAO & RÈLUYỆN THỂ CHẤT</div>
        <div className="legend-items">
          <div className="legend-item">
            <div className="legend-text">Không có dữ liệu</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legend">
      {items.map((group, groupIndex) => (
        <div key={groupIndex} className="legend-group">
          <div className="legend-title">{group.title}</div>
          <div className="legend-items">
            {group.child.map((item) => (
              <div className="legend-item" key={item.id}>
                <div className="legend-id">{item.id}</div>
                <div className="legend-text">{item.title}</div>
              </div>
            ))}
          </div>
          {groupIndex < items.length - 1 && (
            <div className="legend-divider"></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Legend;
